import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlsIntroComponent } from './pls-intro/pls-intro.component';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { RouterModule, Routes } from '@angular/router';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { TranslateModule } from '@ngx-translate/core';
import { PlsOfficialRulesComponent } from './pls-official-rules/pls-official-rules.component';
import {
  AutosaveService,
  AutosaveSettingsComponent,
  AutosaveSimpleSelectorComponent,
} from '@brightside-web/desktop/feature/autosave';
import { PlsContestRewardsComponent } from './pls-contest-rewards/pls-contest-rewards.component';
import { PlsService } from './pls.service';

const routes: Routes = [
  {
    path: 'contest-intro',
    component: PlsIntroComponent,
  },
  {
    path: 'contest-rules',
    component: PlsOfficialRulesComponent,
  },
  {
    path: 'autosave-select',
    component: AutosaveSimpleSelectorComponent,
    data: {
      routeOnSuccess: ['accounts/savings/dashboard'],
      title: 'AUTOSAVE_SELECT_CONTEST_TITLE',
      description: 'AUTOSAVE_SELECT_DESC',
      recommendedValue: 15,
      options: [10, 15, 20],
      chooseOwnRoute: ['pls/autosave'],
    },
  },
  {
    path: 'autosave',
    component: AutosaveSettingsComponent,
    data: {
      routeOnSuccess: ['accounts/savings/dashboard'],
    },
  },
  {
    path: 'contest-details',
    component: PlsContestRewardsComponent,
  },
  {
    path: '**',
    redirectTo: 'contest-intro',
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedDesktopModule, 
    BrightsideUiModule,
    MicroUiMoleculeModule,
    TranslateModule,
  ],
  declarations: [PlsIntroComponent, PlsOfficialRulesComponent, PlsContestRewardsComponent],
  providers: [PlsService, AutosaveService],
})
export class DesktopFeaturePrizeLinkSavingsModule {}
